import React from 'react'

import { TreeView } from '@mui/x-tree-view'
import AccountTreeItem from 'components_new/molecules/AccountTreeItem'

import Icon from 'components_new/atoms/Icon'

import Text from 'components_new/atoms/Text'
import Box from 'components_new/atoms/Box'

/**
 * Tree component from antd, adjusted to Homepal's use cases
 * https://ant.design/components/tree/
 *
 * @param {boolean} checkable - Enables checkboxes before the nodes
 * @param {array} data - An array with objects containing data with props
 * { title: ReactNode, key: string, children: array }
 * @param {ReactNode} header - ReactNode containing a header for the tree
 * @param {number} height - Max height of tree, needs to be a number for
 * scroll to work as intended
 * @param {array} checkedKeys - An array containing all checked keys
 * @param {() => array} setCheckedKeys - Function that sets what keys
 * are checked
 * @param {string} className - Class name for the surrounding container
 * @returns a tree of nodes
 */
const Tree = ({ data = [], header, height, checkedKeys, setCheckedKeys }) => {
  return (
    <Box
      sx={{
        height: height,
        border: '1px solid var(--grey3)',
        'border-radius': 5
      }}
    >
      {header}

      {data.length === 0 ? (
        <Text>Ingen data</Text>
      ) : (
        <TreeView
          defaultCollapseIcon={<Icon name="ExpandMore" />}
          defaultExpandIcon={<Icon name="ChevronRight" />}
        >
          {data.map((item) => (
            <AccountTreeItem
              disabled={false}
              key={item.key}
              nodeId={item.key}
              onToggle={() => {
                if (
                  item.children.every((child) =>
                    checkedKeys.includes(child.key)
                  )
                ) {
                  setCheckedKeys(
                    checkedKeys.filter(
                      (key) => !item.children.map((c) => c.key).includes(key)
                    )
                  )
                } else {
                  setCheckedKeys([
                    ...checkedKeys,
                    ...item.children.map((c) => c.key)
                  ])
                }
              }}
              label={item.title}
              selected={
                item.children.some((child) => checkedKeys.includes(child.key))
                  ? 'indeterminate'
                  : false
              }
            >
              {item.children.map((child) => (
                <AccountTreeItem
                  disabled={false}
                  key={child.key}
                  nodeId={child.key}
                  onToggle={() => {
                    if (checkedKeys.includes(child.key)) {
                      setCheckedKeys(
                        checkedKeys.filter((key) => key !== child.key)
                      )
                    } else {
                      setCheckedKeys([child.key])
                    }
                  }}
                  label={child.title}
                  selected={checkedKeys.includes(child.key) ? 'checked' : false}
                />
              ))}
            </AccountTreeItem>
          ))}
        </TreeView>
      )}
    </Box>
  )
}

export default Tree
